// extracted by mini-css-extract-plugin
export default {"page":"Privacy_page__nM2wE","container":"Privacy_container__timlE","title":"Privacy_title__5JHjd","subtitle":"Privacy_subtitle__kwQyZ","text":"Privacy_text__kzx7T"};